var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/closeCircle.7ea6d1ee.png","uri@2x": __webpack_public_path__ + "static/media/closeCircle.0d2dcc42.png","uri@3x": __webpack_public_path__ + "static/media/closeCircle.4c0edbe9.png",
    width: 20,
    height: 20
});